import { render, staticRenderFns } from "./PremiumsDisplayTable.vue?vue&type=template&id=51e7e577&scoped=true"
import script from "./PremiumsDisplayTable.vue?vue&type=script&lang=js"
export * from "./PremiumsDisplayTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e7e577",
  null
  
)

export default component.exports